module.exports = __webpack_public_path__ + "img/archway-dark.008daa93.svg";